var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"artists-you-collect__description\">Adding artists that you collect will help Artsy and galleries to best serve your needs when answering your inquiry.</div><div class=\"artists-you-collect__user-interests js-artists-you-collect__user-interests\"></div>");;return buf.join("");
};
module.exports = template;